

















import { Component, Prop, Model, Watch, Vue } from 'vue-property-decorator';
import { mdiSend } from '@mdi/js';
import { VuetifyIconComponent } from 'vuetify/types/services/icons';

export const VOICE = 'voice';
export const TOUCH = 'touch';
export const KEYBOARD = 'keyboard';

export interface UserResponse {
    value: string;
    /** https://developers.google.com/actions/reference/rest/Shared.Types/InputType */
    inputType: 'voice' | 'touch' | 'keyboard';
    confidence?: number;
    alternatives?: Array<{
        value: string;
        /** number between 0 and 1 */
        confidence: number;
    }>;
}

export interface SpeechRecognitionConfig {
  /**
   * Controls whether continuous results are returned for each recognition, or only a single result.
   * Defaults to single (false)
   */
  continuous?: boolean;
  /**
   * Controls whether interim results should be returned (true) or not (false)
   * Interim results are results that are not yet final
   */
  interimResults?: boolean;
  /**
   * Sets the maximum number of SpeechRecognitionAlternatives provided per result.
   * The default value is 1.
   */
  maxAlternatives?: number;
  /**
   * Sets the language of the recognition - eg 'en-US'
   * If not specified, this defaults to the HTML lang attribute value,
   * or the user agent's language setting if that isn't set either.
   */
  locale?: string;
}

const SpeechRecognition: any /*SpeechRecognitionStatic*/ =
  (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
// var SpeechGrammar: SpeechGrammarStatic = (window as any).SpeechGrammar || (window as any).webkitSpeechGrammar;
// var SpeechGrammarList: any /*SpeechGrammarListStatic*/ = (window as any).SpeechGrammarList
//                                                      || (window as any).webkitSpeechGrammarList;
// var SpeechRecognitionEvent: SpeechRecognitionEvent = (window as any).SpeechRecognitionEvent
//                                                      || (window as any).webkitSpeechRecognitionEvent;

/**
 * emits 'change' when a user types in the input box, could be used to show an auto-complete
 * emits 'response' when the user submits the text or recognition ends
 */
@Component
export default class VoiceInput extends Vue {
  /** Initial configuration of the SpeechRecognition API */
  @Prop({required: false}) public config?: SpeechRecognitionConfig;
  private listening: boolean = false;
  private value: string = '';
  private recognition?: SpeechRecognition;
  private icons = {
      send: mdiSend
  };

  private created() {
    if (SpeechRecognition) {
      this.toggleMic = this.toggleMic.bind(this);
      this.onResult = this.onResult.bind(this);

      this.recognition = new SpeechRecognition();

      if (this.config) {
        for (const key in this.config) {
          if (this.config.hasOwnProperty(key)) {
              (this.recognition as any)[key] = (this.config as any)[key];
          }
        }
      }

      this.recognition!.onresult = this.onResult;
      this.recognition!.onend = this.toggleMic;
    }
  }

  private toggleMic(e: Event) {
      if (e.type === 'end') {
      // the SpeechRecognition system has stopped listening
      this.listening = false;
    } else {
      setTimeout(() => {
          ((this.$refs.micBtn as any).$el as HTMLButtonElement).blur();
      }, 200);

      this.listening = !this.listening;
      if (this.listening) {
          try {
              this.recognition!.start();
          } catch (err) {
              console.info('failed to listen:', err);
          }
      } else {
        this.recognition!.abort();
      }
    }
  }

  private onResult(sre: any /*SpeechRecognitionEvent*/) {
        // sre.resultIndex - lowest index in the SpeechRecognitionResultList "array" that has actually changed
        // if (sre.results.length > 1) { alert(sre.results.length + ' results'); }
      console.info('onresult:', sre);
      const srr = sre.results[0];

      if (srr.isFinal) {
            const response: UserResponse = {
                value: srr[0].transcript,
                confidence: srr[0].confidence,
                inputType: VOICE
            };

            if (srr.length > 1 && srr[0].confidence < 1) {
                response.alternatives = [];
                for (let i = 1; i < srr.length; i++) {
                    response.alternatives.push({value: srr[i].transcript, confidence: srr[i].confidence});
                }
            }

            this.value = response.value;
            this.$emit('response', response);
        } else {
            this.value = srr[0].transcript;
        }
    }

  private onChange(value: string) {
    // this.value = value;
    // Stop listening when user uses the <input>
    if (this.listening) {
      this.recognition!.abort();
    }
    this.$emit('change', {value, inputType: KEYBOARD});
  }

  private onSubmit() {
    if (this.value && this.value !== '') {
      this.$emit('response', {value: this.value, inputType: KEYBOARD});
    }
  }
}
